import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import Layout from "../../components/Layout/Layout";
import InputComponent from "../../components/InputComponent";
import Toast from "../../helpers/Toast";
import PageTitle from "../../components/Layout/PageTitle";
import { PartService } from "../../services/PartService";
import { PartDTO } from "../../models/Parts/PartDTO";
import { PartCreateDTO } from "../../models/Parts/PartCreateDTO";
import useValidationSchema, {FieldConfig } from "../../components/Validations";

export default function PartCreate() {
    const intl = useIntl();
    const partService = new PartService();
    const [loadingCreate, setLoadingCreate] = useState<boolean>(false);
    const [part, setPart] = useState<PartDTO>({} as PartDTO);

    const navigate = useNavigate();

    const fields: FieldConfig[] = [
        ["erpId", "string", "Screens.Parts.Create.CodeRequired"],
        ["name", "string", "Screens.Parts.Create.NameRequired"],
        ["sellingPrice", "price", "Screens.Parts.Create.SellingPriceRequired"],
        ["costPrice", "price", "Screens.Parts.Create.CostPriceRequired"]
    ];
    
    const schemaClientValidation = useValidationSchema(fields);

    const createPart = async () => {
        setLoadingCreate(true);
        const createPart: PartCreateDTO = {
            erpId: part.erpId || null,
            name: part.name || null,
            sellingPrice: part.sellingPrice || null,
            costPrice: part.costPrice || null,
        };

        const { error } = schemaClientValidation.validate(createPart);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoadingCreate(false);
            return;
        }
        const response = await partService.CreatePart(createPart);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setLoadingCreate(false);
            return;
        }

        Toast.Show("success", response.message);
        setLoadingCreate(false);
        navigate(-1);
    };

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={"Nova Peça"} allowGoBack={true} />
                </div>
                <div className="pageBody">
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Row>
                            <InputComponent
                                xl={2}
                                lg={2}
                                md={2}
                                sm={2}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={part.erpId}
                                label={intl.formatMessage({ id: "Screens.Parts.Info.ErpId" })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setPart({ ...part, erpId: t })
                                }}
                            />
                            <InputComponent
                                xl={3}
                                lg={3}
                                md={3}
                                sm={3}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={part.name}
                                label={intl.formatMessage({ id: "Screens.Parts.Info.Name" })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setPart({ ...part, name: t })
                                }}
                            />
                        </Row>

                        <Row>
                            <InputComponent
                                xl={1}
                                lg={1}
                                md={1}
                                sm={1}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"number"}
                                value={part.sellingPrice}
                                label={intl.formatMessage({ id: "Screens.Parts.Info.SellingPrice" })}
                                readOnly={false}
                                onChange={(t: number) => {
                                    setPart({ ...part, sellingPrice: t })
                                }}
                            />
                            <InputComponent
                                xl={1}
                                lg={1}
                                md={1}
                                sm={1}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"number"}
                                value={part.costPrice}
                                label={intl.formatMessage({ id: "Screens.Parts.Info.CostPrice" })}
                                readOnly={false}
                                onChange={(t: number) => {
                                    setPart({ ...part, costPrice: t })
                                }}
                            />
                        </Row>

                        <Row style={{ margin: "0px", marginTop: "10px", padding: "0px" }}>
                            <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                                <ButtonComponent
                                    disabled={loadingCreate}
                                    loading={loadingCreate}
                                    text={intl.formatMessage({ id: "Screens.Parts.Create.Save" })}
                                    onClick={createPart}
                                />
                            </Col>
                        </Row>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}
